<template>
  <div class="page-block">
    <Head title="Admin" />
    <h1 class="heading xl mb-2">{{ t('admin') }}</h1>
    <p class="text-xl leading-tight mb-4">{{ t('welcome') }}</p>
    <s-card>
      <template #content>
        <ul class="">
          <li v-for="(item, index) in page.props.menu" :key="index">
            <s-link
              v-if="item.type === 'link'"
              :href="item.href"
              class="group link-subtle flex items-center gap-2.5 px-4 md:px-5 py-1"
              :class="{
                'pt-4': index === 0,
                'pb-4': index === page.props.menu.length - 1,
              }"
            >
              <s-icon
                v-if="item.icon"
                :name="item.icon"
                class="opacity-70 group-hover:opacity-100 transition"
              />
              {{ item.label }}
            </s-link>
            <s-divider v-else-if="item.type === 'divider'" class="my-2.5 opacity-50" />
          </li>
        </ul>
      </template>
    </s-card>
  </div>
</template>
<script setup lang="ts">
import {Head, usePage} from '@inertiajs/vue3';
import {useI18n} from 'vue-i18n';
import SLink from '../../components/SLink.vue';
import SCard from '../../design-system/SCard.vue';
import SIcon from '../../design-system/SIcon.vue';
import SDivider from '../../design-system/SDivider.vue';
import {SidebarItem} from '../../components/sidebar/types.js';

const {t} = useI18n();
const page = usePage<{menu: SidebarItem[]}>();
</script>
<i18n>
{
  "en": {
    "admin": "Admin",
    "welcome": "Welcome to the admin dashboard!"
  },
  "fr": {
    "admin": "Admin",
    "welcome": "Bienvenue au tableau de bord de l'administrateur !"
  }
}
</i18n>
